export default function SignalRApi({ makeRequest, buildRequest }) {

    function getSignalRConnection() {
        return buildRequest().then(function (req) {
            return makeRequest(req.get('/api/SignalR/negotiate'));
        });
    }

    return {
        getSignalRConnection,
    };
}
